"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloseableCardHandler_1 = require("../../components/CloseableCardHandler");
CloseableCardHandler_1.CloseableCardHandler.each('.manage-interests');
